<template>
  <div>
    <div>
      <el-form-item label="地区：" :label-width="labelWidth||'120px'" v-if="isShowArea">
        <AreaPicker ref="AreaPicker" :areaIdsChecked="areaIdsChecked" @change="areaChange" />
      </el-form-item>

      <div v-for="(x,i) in formItems" :key="i">
        <el-form-item :label="x.label+'：'" :label-width="labelWidth||'120px'" v-if="x.type!=='row'">
          <span slot="label" v-if="!!x.labelSoltcb" class="label-icon" @click="x.labelSoltcb()">
            {{x.label}}
            <i class="el-icon-warning-outline"></i>
            ：
          </span>

          <template v-if="x.type==='text'">
            <el-input
              clearable size="mini" :style="x.style||'width:384px;'"
              v-model="eData[x.key]" :disabled="x.disabled" :placeholder="x.placeholder"
              @input="inputChangeHandler"></el-input>
          </template>

          <template v-if="x.type==='number'">
            <el-input
              clearable size="mini" :style="x.style||'width:384px;'"
              v-model="eData[x.key]" :disabled="x.disabled" :placeholder="x.placeholder"
              @input="inputChangeHandler" @keyup.native="numberFormat(x.key)"></el-input>
          </template>

          <template v-if="x.type==='botton'">
            <el-input
              clearable size="mini" :style="x.style||'width:318px;'"
              v-model="eData[x.key]" :disabled="x.disabled" :placeholder="x.placeholder"
              @input="inputChangeHandler"></el-input>
            <el-button size="mini" :type="x.btnType||'primary'" @click="x.callback" :style="x.btnStyle||'margin-left:10px;'">{{x.btnText||'确定'}}</el-button>
          </template>

          <template v-if="x.type==='textarea'">
            <el-input
              clearable size="mini" :style="x.style||'width:384px;'"
              :rows="4" type="textarea"
              v-model="eData[x.key]" :disabled="x.disabled" :placeholder="x.placeholder"
              @input="inputChangeHandler"></el-input>
          </template>

          <template v-if="x.type==='richText'">
            <EditorBar v-model="eData[x.key]"></EditorBar>
          </template>

          <template v-if="x.type==='switch'">
            <el-switch
              v-model="eData[x.key]" :disabled="x.disabled"
              :inactive-text="x.left" :active-text="x.right"
              :inactive-value="x.left" :active-value="x.right"
              @change="(val)=>{x.callback?x.callback(val):'',switchChangeHandler(val,x.key)}"></el-switch>
          </template>

          <template v-if="x.type==='select_s'">
            <el-select
              clearable filterable size="mini" :style="x.style||'width:384px;'"
              v-model="eData[x.key]" :disabled="x.disabled" :placeholder="x.placeholder"
              @change="(val)=>{x.callback?x.callback(val):'',selectChangeHandler(val,x.key)}"
              :remote="!!x.remoteMethod" :remote-method="x.remoteMethod?x.remoteMethod:()=>{}">
              <el-option v-for="(x2, i2) in x.options" :key="i2" :label="x2.label||x2" :value="x2.label?x2.value:x2"></el-option>
            </el-select>
          </template>

          <template v-if="x.type==='select_m'">
            <el-select
              clearable filterable size="mini" :style="x.style||'width:384px;'"
              v-model="eData[x.key]" :disabled="x.disabled" :placeholder="x.placeholder"
              multiple @change="(val)=>{x.callback?x.callback(val):'',selectChangeHandler(val,x.key)}">
              <el-option v-for="(x2, i2) in x.options" :key="i2" :label="x2.label||x2" :value="x2.label?x2.value:x2"></el-option>
            </el-select>
          </template>

          <template v-if="x.type==='date'">
            <el-date-picker
              clearable size="mini" type="datetime" :style="x.style||'width:384px;'"
              v-model="eData[x.key]" :disabled="x.disabled" :placeholder="x.placeholder||'选择时间'"
              :default-time="x.defaultTime||'00:00:00'" format="yyyy-MM-dd HH:mm:ss" value-format="timestamp"></el-date-picker>
          </template>
          
          <template v-if="x.type==='cascader'">
            <el-cascader
              clearable filterable size="mini" :style="x.style||'width:384px;'"
              v-model="eData[x.key]" :disabled="x.disabled" placeholder="输入关键字"
              :options="x.options" :props="{ expandTrigger: 'hover' }"
              @change="cascaderChangeHandler"></el-cascader>
          </template>

          <template v-if="x.type==='upload'||x.type==='image'">
            <p style="height:40px;line-height:32px;font-size:12px;">建议尺寸{{x.size?x.size:'750px*750px'}}，建议格式jpg，限制{{$data['fileList_'+x.index].length+'/'+(x.limitNum||1)}}张</p>
            <el-upload
              :action="action" multiple :limit="(x.limitNum||1)" accept=".jpg,.jpeg,.png,.bmp,.gif"
              :file-list="$data['fileList_'+x.index]" list-type="picture-card"
              class="upload-image" :class="{'disabled':$data['fileList_'+x.index].length>=(x.limitNum||1)}"
              :on-success="(rep,file,fileList)=>handleSuccess(rep,file,fileList,x.index)"
              :on-error="(err,file,fileList)=>handleError(err,file,fileList,x.index)"
              :on-remove="(file,fileList)=>handleRemove(file,fileList,x.index)"
              :on-exceed="handleExceed"
              :on-preview="handlePictureCardPreview"
              :before-upload="beforeUpload">
              <i class="el-icon-plus"></i>
            </el-upload>
          </template>

          <template v-if="x.type==='video'">
            <video v-if="$data['fileList_'+x.index].length" controls :src="_img_handler($data['fileList_'+x.index][0].id)" class="video">您的浏览器不支持视频播放</video>
            <el-upload
              :action="action" :accept="x.accept||'.mp4,.mkv,.rm,.rmvb,.mpeg1-4,.mov,.mtv,.dat,.wmv,.avi,.3gp,.amv,.dmv,.flv'"
              class="upload-video" :class="{'disabled':$data['fileList_'+x.index].length>=(x.limitNum||1)}"
              :data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
              :file-list="$data['fileList_'+x.index]" :limit="(x.limitNum||1)"
              :on-progress="(event,file,fileList)=>handleProcess(event,file,fileList,x.index)"
              :on-success="(rep,file,fileList)=>handleSuccess(rep,file,fileList,x.index)"
              :on-remove="(file,fileList)=>handleRemove(file,fileList,x.index)"
              :before-upload="(file)=>beforeUpload2(file,x.index,(x.limitNum||1))">
              <i v-if="!$data['fileList_'+x.index].length" class="el-icon-plus upload-video-icon"></i>
              <!-- <el-progress v-if="$data['flag_'+x.index]" type="circle" :percentage="videoUploadPercent" style="margin-top:7px;"></el-progress> -->
            </el-upload>
          </template>

          <template v-if="x.type==='document'">
            <el-upload
              style="width:384px;"
              :action="action" multiple :accept="x.accept||'.docx,.doc,.xls,.xlsx,.pdf'"
              :file-list="$data['fileList_'+x.index]" :limit="(x.limitNum||1)"
              :on-success="(rep,file,fileList)=>handleSuccess(rep,file,fileList,x.index)"
              :on-error="(err,file,fileList)=>handleError(err,file,fileList,x.index)"
              :on-remove="(file,fileList)=>handleRemove(file,fileList,x.index)"
              :on-exceed="handleExceed">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">仅支持上传{{x.accept||'.docx,.doc,.xls,.xlsx,.pdf'}}文件，限制{{$data['fileList_'+x.index].length+'/'+(x.limitNum||1)}}个</div>
            </el-upload>
          </template>

        </el-form-item>

        <template v-else-if="x.type==='row'">
          <div v-for="(x2,i2) in x.time" :key="i2">
            <el-form-item :label="x3.label+' '+x2+'：'" :label-width="labelWidth||'120px'" v-for="(x3,i3) in x.children" :key="i3">
              <template v-if="x3.type==='text'">
                <el-input clearable size="mini" :style="x3.style||'width:384px;'" v-model="eData[x.key][i2][x3.key]" :disabled="x3.disabled" :placeholder="x3.placeholder" @input="inputChangeHandler"></el-input>
              </template>
            </el-form-item>
          </div>
        </template>
      </div>

    </div>

    <!-- 图片预览 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import mixin_upload from '@/Mixins/mixin_upload'
import AreaPicker from '@/components/AreaPicker'
// 导入安装好的wangeditor
import E from 'wangeditor'
// 导入封装好的公共组件wangEditor
import EditorBar from '@/components/wangEditor'
export default {
  mixins: [mixin_upload],
  components: { EditorBar, AreaPicker },
  props: {
    action: { type: String },
    labelWidth: { type: String },
    formItems: { type: Array },
    isShowArea: { type: Boolean, default: true },
    areaIdsChecked: { type: Array },
  },
  data() {
    return {
      eData: {},
      time: 0
    }
  },
  // computed: {
  //   formItems() {
  //     return [
  //       { type: 'image', key: 'welcomeImg', label: '系统欢迎图', size: '无', limitNum: 1, index: 1 },
  //       { type: 'text', key: 'title', label: '系统名称' },
  //       { type: 'image', key: 'logoId', label: '系统logo', size: '120px*120px', limitNum: 1, index: 2 },
        // { type: 'image', key: 'showImgId', label: '地图弹框图片', size: '无', limitNum: 1, index: 2 },
        // { type: 'text', key: 'showDesc', label: '地图弹框描述' },
        // { type: 'text', key: 'policyUrl', label: '政府法规' },
        // { type: 'text', key: 'socialUrl', label: '人社业务' },
  //       { type: 'text', key: 'rsrcTitle', label: '人事人才名称' },
  //       { type: 'image', key: 'rsrcLogo', label: '人事人才logo', size: '120px*120px', limitNum: 1, index: 3 },

  //       { type: 'text', key: 'holdSide', label: '3g视吧主办方' },
  //       { type: 'text', key: 'rsrcHoldSide', label: '人事人才主办方' },
  //       { type: 'text', key: 'maintain', label: '3g视吧维权' },
  //       { type: 'text', key: 'rsrcMaintain', label: '人事人才维权' },

  //       { type: 'row', key: 'nameAndUrlList', children: [
  //         { type: 'text', key: 'name', label: '链接标题' },
  //         { type: 'text', key: 'url', label: '链接url' },
  //       ], time: this.time }



  //       // { type: 'select_s', key: 'o_domain', label: '所属行业', options: this.$fuwuData.suoshuhangye3g },
  //       // { type: 'image', key: 'o_homeUrl', label: '企业logo', size: '120px*120px', limitNum: 1, index: 1 },
  //       // { type: 'video', key: 'o_videoUrl', label: '视频简介', index: 3 },
  //     ]
  //   },
  // },
  methods: {
    numberFormat(val) {
      // console.log(this.eData[val])
      this.eData[val] ? this.eData[val] = this.eData[val].replace(/[^\.\d]/g,'') : ''
    },
    inputChangeHandler(val) {
      // console.log(val, this.eData)
    },
    switchChangeHandler(val, key) {
      // console.log(val, this.eData)
    },
    selectChangeHandler(val, key) {
      // console.log(val, this.eData)
    },
    cascaderChangeHandler(val) { // 对话框中 分类选中
      // console.log(val, this.eData)
    },
    areaChange(areaIds) {
      this.$emit('areaChange', areaIds)
    },
    modifyHandler(row) {
      this.eData = JSON.parse(JSON.stringify(row))

      let items = this.formItems.filter(x => x.index)
      this.modifyDateHandler(items)

      if (this.formItems2) {
        let items = this.formItems2.filter(x => x.index)
        this.modifyDateHandler(items)
      }
    },
    modifyDateHandler(items) {
      items.forEach(x => {
        let target = this.eData[x.key]
        switch (x.type) {
          case 'image':
          case 'video':
            if (target && target.length > 0) {
              if (x.limitNum > 1) {
                this['fileList_' + x.index] = target.map(x2 => {
                  return { name: x2, url: this._img_handler(x2), id: x2 }
                })
              } else {
                this['fileList_' + x.index] = [
                  { name: target, url: this._img_handler(target), id: target }
                ]
              }
            } else {
              this['fileList_' + x.index] = []
            }
            break;
          case 'document':
            if (target && (target.fileId || target.length > 0)) {
              if (x.limitNum > 1) {
                this['fileList_' + x.index] = target.map(x2 => {
                  return { name: x2.fileName, url: this._img_handler(x2.fileId), id: x2.fileId }
                })
              } else {
                this['fileList_' + x.index] = [
                  { name: target.fileName, url: this._img_handler(target.fileId), id: target.fileId }
                ]
              }
            } else {
              this['fileList_' + x.index] = []
            }
            break;
        }
      })
    },
    submitHandler() { // 对话框 提交
      let items = this.formItems.filter(x => x.index)
      this.submitDateHandler(items)

      // if (this.formItems2) {
      //   let items = this.formItems2.filter(x => x.index)
      //   this.submitDateHandler(items)
      // }
      
      if (this.isShowArea) {
        let areaNames = this.$refs.AreaPicker.findAreaNames()
        // console.log(`%careaNames:`, 'color: #f00;', areaNames)
        this.eData.province = areaNames[0]
        this.eData.city = areaNames[1]
        this.eData.county = areaNames[2]
        this.eData.town = areaNames[3]
        this.eData.village = areaNames[4]
      }

      this.$emit('submitHandler', this.eData)
      return this.eData
    },
    submitDateHandler(items) {
      items.forEach(x => {
        if (!x.limitNum || x.limitNum === 1) {
          this.eData[x.key] = ''
        } else {
          this.eData[x.key] = []
        }
        this['fileList_' + x.index].forEach(x2 => {
          switch (x.type) {
            case 'upload':
            case 'image':
            case 'video':
              !x.limitNum || x.limitNum === 1 ? this.eData[x.key] = x2.id : this.eData[x.key].push(x2.id)
              break;
            case 'document':
              !x.limitNum || x.limitNum === 1 
              ? this.eData[x.key] = {
                fileName: x2.name,
                fileId: x2.id,
              }
              : this.eData[x.key].push({
                fileName: x2.name,
                fileId: x2.id,
              })
              break;
          }
        })
      })
    }
  },
}
</script>

<style lang='scss' scoped>
// 上传 ↓
/deep/ .upload-image .el-upload--picture-card,
/deep/ .upload-image .el-upload-list__item {width:90px;height:90px;position:relative;transition:none !important;} // 图片盒子大小
/deep/ .upload-image .el-icon-plus {width:28px;height:28px; position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;} // 图片加号位置
/deep/ .disabled .el-upload--picture-card {display:none} // 图片超出数量限制 隐藏上传按钮
// 上传 ↑

/deep/ .el-form-item__label,
/deep/ .el-cascader__search-input,
/deep/ .el-radio__label {font-size: 14px;}

/deep/ .el-form-item {margin-bottom:10px;} // 设置每行间距


/deep/ .el-input--mini .el-input__icon {height: 28px;line-height: 28px;} // 选择器 icon位置


/deep/.el-select__tags{overflow: auto;}


// 视频 ↓
/deep/.upload-video .el-upload--text {border: 1px dashed #c0ccda;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;}
/deep/.upload-video .el-upload--text:hover {border-color: #409EFF;color: #409EFF;}
.upload-video-icon {
  width:90px;height:90px;line-height:90px;text-align: center;
  background-color: #fbfdff;font-size: 28px;color: #8c939d;
}
/deep/.el-upload-list--text{width: 400px;}
.video{width: 400px;max-height: 240px;}
/deep/ .disabled .el-upload--text{display: none;}
// 视频 ↑



.label-icon{
  cursor: pointer;position: relative;
  &:hover{
    color: #409EFF;
  }
    &::after {
      content: '点击查看';display: inline-block;width: 80px;height: 32px;line-height: 32px;text-align: center;
      border: 1px solid #ccc;position: absolute;top: 30px;left: 0;right: 0;margin: auto;
    }
}
</style>